module.exports = __webpack_public_path__ + "img/dcom10.a0b7f97a.png";